
<template>
  <div class="u-table-wrapper" :class="{ 'has-pagination-info': showPaginationInfo }">
    <div v-if="showPaginationInfo" class="u-table-pagination-info">
      共 {{ Math.ceil(curParams.total / curParams.size) || 0 }} 页， {{ curParams.total }}条{{
        hasSelection ? `，已选${selectedRowsCount}条` : ""
      }}
    </div>

    <el-table
      ref="tableRef"
      header-row-class-name="u-table-hd"
      header-cell-class-name="u-table-hd__cell"
      :show-header="showHeader"
      :row-class-name="tableRowClassName"
      :data="items"
      :border="true"
      @select="handleSelectionChange"
      @select-all="handleSelectionAll"
      @cell-click="handleCellClick"
      @sort-change="handleSortChange"
      :row-key="rowKey"
      :empty-text="emptyText"
      v-loading="loading"
      :height="height || undefined"
      :style="{width: '100%'}"
    >
      <template #empty>
        <el-empty description="暂无数据～" />
      </template>
      <el-table-column
        v-if="hasSelection"
        type="selection"
        label="全选"
        width="30"
        :reserve-selection="true"
        :selectable="selectable"
      />
      <el-table-column
        v-if="hasSerialNumber"
        label="序号"
        width="55"
        :align="serialNumberConfig.align || 'left'"
      >
        <template #default="scope">
          {{ filters.tableIndex(scope.$index, curParams?.current || 0, curParams?.size || 0) }}
        </template>
      </el-table-column>
      <template v-for="(item, i) in tableColumns" :key="i">
        <!-- 插槽 format -->
        <el-table-column
          v-if="item.format || (item.slot && !item.hidden)"
          :prop="item.value"
          :label="item.name"
          :width="item.width"
          :align="item.align || 'left'"
          :fixed="item.fixed"
          :class-name="item.className || ''"
          :sortable="item.sortable || false"
          :show-overflow-tooltip="!item.newline"
        >
          <template v-if="item.headerTip" #header>
            {{ item.name }}
            <el-tooltip :content="item.headerTip" placement="top" popper-class="tooltip_box">
              <el-icon style="position: relative; top: 2px; color: #aaa">
                <WarningFilled />
              </el-icon>
            </el-tooltip>
          </template>
          <template #default="scope">
            <template v-if="item.format">
              {{ item.format(scope.row[item.value], scope.row, scope) }}
            </template>
            <slot
              v-if="item.slot"
              :name="item.value"
              :item="scope.row"
              :record="scope.row[item.value]"
              :rowInfo="{
                index: scope.$index,
                serialIndex: filters.tableIndex(
                  scope.$index,
                  curParams ? curParams.current : 0,
                  curParams ? curParams.size : 0
                ),
              }"
            ></slot>
          </template>
        </el-table-column>

        <!-- 常规展示 -->
        <el-table-column
          v-if="!(item.format || item.slot) && !item.hidden"
          :prop="item.value"
          :label="item.name"
          :width="item.width"
          :align="item.align || 'left'"
          :sortable="item.sortable || false"
          :fixed="item.fixed"
          :class-name="item.className || ''"
          :show-overflow-tooltip="!item.newline"
        />
      </template>
    </el-table>

  </div>
</template>
<script>
import { inject, reactive, toRefs, watch, ref, onMounted } from "vue"
import { WarningFilled, Setting } from "@element-plus/icons-vue"

export default {
  name: "TmTable",
  components: {
    WarningFilled,
    Setting
  },
  props: {
    // 显示复选框
    hasSelection: {
      type: Boolean,
      default: false,
    },
    //显示序号
    hasSerialNumber: {
      type: Boolean,
      default: false,
    },
    serialNumberConfig: {
      type: Object,
      default: new Object(),
    },
    // 显示 '共 x 页， xx条'
    showPaginationInfo: {
      type: Boolean,
      default: false,
    },
    // 显示隐藏表头
    showHeader: {
      type: Boolean,
      default: true,
    },
    // 表头
    columns: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 数据
    data: {
      type: Array,
      default: () => {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // 解决拖拽排序 顺序混乱问题
    rowKey: {
      type: String,
      default: "id",
    },
    // 默认选中复选框回填
    selectedRows: {
      type: Array,
      default: () => [],
    },
    // 数据为空提示
    emptyText: {
      type: String,
      default: "暂无数据～",
    },
    rowClass: {
      type: Function,
    },
    selectable: {
      type: Function,
    },
    height: [String, Number],
  },
  setup(props, { emit, attrs }) {
    const filters = inject("$filters")
    const popoverRef = ref()
    const tableRef = ref(null)
    const state = reactive({
      items: props.data || [],
      curParams: attrs.params,
      tableColumns: props.columns || [],
      selectedRowsCount: 0, //勾选数量
      /* 自定义列相关 */
      originColumns: [...(props.columns || [])],
      templateType: 0, //自定义列类型
      cols: [], //自定义列
      colTemp: {
        pageType: props.colSetParam,
      },
    })

    onMounted(() => {
      if (props.hasSelection) {
        setCheckedRows(props.selectedRows)
      }
    })

    watch(
      () => props.data,
      newItems => {
        _deactivated()
        state.items = Array.isArray(newItems) ? newItems : []
        if (props.hasSelection) {
          setCheckedRows(props.selectedRows)
        }
      }
    )

    watch(
      () => props.columns,
      newItems => {
        state.tableColumns = newItems
        state.originColumns = [...(newItems || [])]
      },
      {
        deep: true,
      }
    )
    /**
     * @description: 解决tooltip 不消失问题
     * @return {*}
     */
    function _deactivated() {
      let list = document.getElementsByClassName("el-popper")
      for (let i = 0, len = list.length; i < len; i++) {
        list[i].style.display = "none"
      }
    }
    /**
     * @description: 选项切换
     * @param {*} rows
     * @return {*}
     */
    const handleSelectionChange = (selection, rows) => {
      state.selectedRowsCount = selection.length
      setTimeout(() => {
        emit("selectionChange", {
          selection: [...new Set(selection)],
          row: rows,
        })
      }, 50)
    }
    const handleSortChange = (val) => {
      setTimeout(() => {
        emit("sortChange", val)
      }, 50)
    }
    /**
     * @description: 全选
     * @return {*}
     */
    const handleSelectionAll = selection => {
      state.selectedRowsCount = selection.length
      setTimeout(() => {
        emit("selectionChange", {
          selection: [...new Set(selection)],
          row: null,
        })
      }, 50)
    }
    /**
     * @description: 行样式
     * @param {*}
     * @return {*}
     */
    const tableRowClassName = ({ rowIndex }) => {
      let diyClassName = ""
      if (props.rowClass && typeof props.rowClass == "function") {
        diyClassName = props.rowClass(rowIndex)
      }
      if (rowIndex % 2 == 0) {
        return "even-row " + diyClassName
      } else {
        return "odd-row " + diyClassName
      }
    }

    const setCheckedRows = (rows = []) => {
      tableRef.value?.clearSelection()
      let c = 0 //勾选计数
      rows.forEach(row => {
        const tableItemIndex = state.items.findIndex(v => v.id == row.id)
        tableItemIndex > -1 &&
          tableRef.value?.toggleRowSelection(state.items[tableItemIndex], true) &&
          c++
      })
      state.selectedRowsCount = c
    }

    const clearSelection = () => {
      state.selectedRowsCount = 0
      tableRef.value?.clearSelection()
    }

    const handleCellClick = (row, column, cell, event) => {
      emit("cellClick", { row, column, cell, event })
    }

    return {
      popoverRef,
      filters,
      tableRef,
      ...toRefs(state),
      handleSelectionChange,
      handleSelectionAll,
      handleCellClick,
      tableRowClassName,
      clearSelection,
      setCheckedRows,
      handleSortChange,
    }
  },
}
</script>
<style lang="less" scoped>
.u-table-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  &.has-pagination-info {
    padding-top: 52px;
  }
}

.u-table-pagination-info {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 14px;
  padding: 8px 0;
}

.el-table {
  width: 100%;
  height: 100%;
  --el-table-row-hover-bg-color: #dfeaff;
  &::before {
    background: transparent;
  }
  :deep(.cell) {
    padding: 0 5px;
  }
}
:deep(.u-table-hd) {
  height: 40px;
  line-height: 40px;
  color: @themeFontColor;
  background: #f6f8fa;
  font-family: PingFangSC-Medium, PingFang SC;
  &__cell {
    padding: 0;
    border-bottom: none !important;
    background-color: #f6f8fa !important;
  }
}
:deep(.el-table__body) {
  border-collapse: collapse;
  .el-table__row {
    border-bottom: 1px solid #f6f8fa;
  }
  .even-row,
  .odd-row {
    .el-table__cell {
      padding: 8px 0;
      color: #000;
      background-color: transparent;
    }
    .el-table-fixed-column--right {
      background: #fff;
    }
  }
  .odd-row {
    background-color: #f0f4fa;
    .el-table__cell {
      background-color: #f0f4fa;
    }
    .el-table-fixed-column--right {
      background: #f0f4fa;
    }
  }
  .even-row {
    background-color: #fff;
    .el-table__cell {
      background-color: #fff;
    }
  }
  .even-row:hover,
  .odd-row:hover {
    .el-table__cell {
      background-color: #e9f1ff !important;
    }
    .el-table-fixed-column--right {
      background: #e9f1ff !important;
    }
  }
  .disabled {
    .el-table__cell {
      color: #ccc;
    }
    .iconfont {
      opacity: 0.7;
    }
    .el-button,
    .el-switch,
    .el-select {
      opacity: 0.7;
    }
  }
  .even-row {
    .el-table__cell {
      border-bottom: none;
    }
  }
  .odd-row {
    .el-table__cell {
      border-bottom: none;
    }
  }

  .tb-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
    font-weight: 600;
    color: #151a1d;
    cursor: default;
  }

  .u-tb-status {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: 6px;
    border-width: 1px;
    border-style: solid;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    text-align: center;
    border-radius: 4px;
    &:hover {
      opacity: 0.8;
    }
  }
  .tm-icon-caozuo-bianji {
    margin-left: 5px;
    font-size: 16px;
    vertical-align: middle;
  }
}
.col-set-btn {
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0px;
  font-size: 14px;
  cursor: pointer;
}
.col-checkbox {
  :deep(.el-checkbox) {
    display: block;
    margin-right: 0;
    .el-checkbox__input {
      vertical-align: bottom;
    }
  }
  .move {
    cursor: move;
    :deep(.el-checkbox__input.is-disabled + span.el-checkbox__label) {
      cursor: move;
    }
  }
}

:deep(.cell:empty::before) {
  content: "-";
  color: gray;
}

.el-popper.is-dark {
  max-width: 600px;
}

:deep(.el-table__body-wrapper) {
  width: calc(100% + 2px);
}
</style>
